import type { InstallmentsConfig, Plan } from '@twisto/api-cms/custom-types'

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null

const isPlan = (value: unknown): value is Plan =>
  isRecord(value) &&
  typeof value.months === 'number' &&
  [
    'amount_principal',
    'amount_interest',
    'amount_total',
    'annual_percentage_rate',
    'monthly',
  ].every((key) => typeof value[key] === 'string') &&
  (typeof value.interest_rate === 'string' ||
    (typeof value.amount_fee === 'string' &&
      typeof value.fee_rate === 'string'))

const isPlans = (value: unknown) =>
  value === null || (Array.isArray(value) && value.every(isPlan))

// A marketing maximum alone must not replace the calculator fallback.
export const readInstallmentsCalculatorConfig = (
  value: unknown
): InstallmentsConfig => {
  if (
    !isRecord(value) ||
    typeof value.active_from !== 'string' ||
    !isPlans(value.calculator_config) ||
    !isPlans(value.calculator_config_historical) ||
    typeof value.show_schedule_apr !== 'boolean' ||
    (value.interest_per_year !== null &&
      typeof value.interest_per_year !== 'number')
  ) {
    throw new Error('Invalid installments calculator configuration')
  }

  return value as InstallmentsConfig
}
